// components/ShareAltIcon.jsx
import React from 'react';

const ShareAltIcon = ({ className = "w-6 h-6" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <g>
      <path
        d="M6,9a3,3,0,1,1-3,3A3,3,0,0,1,6,9Zm9,9a3,3,0,1,0,3-3A3,3,0,0,0,15,18Zm3-9a3,3,0,1,0-3-3A3,3,0,0,0,18,9Z"
        fill="#2A5315"
        strokeWidth="2"
      />
      <path
        d="M8.68,13.34l6.62,3.31m-6.62-6L15.3,7.35M6,9a3,3,0,1,1-3,3A3,3,0,0,1,6,9Zm9,9a3,3,0,1,0,3-3A3,3,0,0,0,15,18Zm3-9a3,3,0,1,0-3-3A3,3,0,0,0,18,9Z"
        fill="none"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export default ShareAltIcon;
